import { render, staticRenderFns } from "./CanvaImportReports.vue?vue&type=template&id=42f35523&scoped=true"
import script from "./CanvaImportReports.vue?vue&type=script&lang=js"
export * from "./CanvaImportReports.vue?vue&type=script&lang=js"
import style0 from "./CanvaImportReports.vue?vue&type=style&index=0&id=42f35523&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f35523",
  null
  
)

export default component.exports